const twoFactorAuthHR = {
    "view": {
        "title": "Dvofaktorska autentifikacija",
        "form": {
            "label": {
                "currentMethod": "Trenutna metoda dvofaktorske autentifikacije",
                "authenticatorSetupTitle": "Postavite svoju aplikaciju za autentifikaciju",
                "scanInstructions": "Skenirajte QR kod ispod koristeći bilo koju TOTP aplikaciju za autentifikaciju (poput Authy, Google Authenticator, Microsoft Authenticator itd.).",
                "qrCodeAlt": "QR kod za postavljanje autentifikatora",
                "step1": "Otvorite svoju aplikaciju za autentifikaciju.",
                "step2": "Odaberite opciju za dodavanje novog računa.",
                "step3": "Odaberite opciju \"Skeniraj QR kod\" u aplikaciji.",
                "step4": "Usmjerite kameru svog telefona na QR kod iznad.",
                "step5": "Nakon skeniranja, autentifikator će početi generirati 6-znamenkasti OTP kod koji se osvježava svakih 30 sekundi. Ovaj OTP kod može se koristiti za dovršetak procesa prijave.",
                "appLinks": "Ovdje su poveznice za neke uobičajene aplikacije za autentifikaciju:",
                "appLinksAuthy": "Authy",
                "appLinksGoogle": "Google Authenticator",
                "appLinksMicrosoft": "Microsoft Authenticator",
                "googlePlay": "Google Play Store",
                "appStore": "Apple App Store",
                "loadingQrCode": "Učitavanje QR koda...",
                "emailSetupTitle": "Dvofaktorska autentifikacija putem e-pošte",
                "emailDescription": "Jednokratna lozinka (OTP) bit će poslana na vašu registriranu adresu e-pošte, koja se može koristiti za dovršetak procesa prijave. Provjerite svoju pristiglu poštu ili mapu neželjene pošte za OTP prilikom prijave."
            },
            "help_text": {
                "currentMethod": "E-pošta je trenutno postavljena kao zadana metoda za dvofaktorsku autentifikaciju. Međutim, preporučujemo korištenje metode autentifikatora za poboljšanu sigurnost."
            },
            "option": {
                "2faMethod": {
                    "selectMethod": "Odaberite 2FA metodu",
                    "email": "E-pošta",
                    "auth": "Autentifikator"
                }
            },
            "button": {
                "save": "Spremi",
                "saving": "Spremanje..."
            }
        },
        "backupCodes": {
            "title": "Sigurnosni kodovi",
            "view": {
                "button": {
                    "generate": "Generiraj sigurnosne kodove",
                    "download": "Preuzmi sigurnosne kodove"
                },
                "modal": {
                    "header": "Vaši sigurnosni kodovi",
                    "body": {
                        "noCodes": "Nema dostupnih sigurnosnih kodova"
                    }
                }
            }
        }
    }
};

export default twoFactorAuthHR;